import { gql } from '@apollo/client';

export const ALL_INTERVENTION_PHASES = gql`
  query AllInterventionPhases {
    getInterventionPhases {
      id
      name
    }
  }
`;
